<template>
    <section class="content-table">
      <div class="search-line">
        <DataFilters v-model="filters" />
        <DataSearch v-model="searchText" v-model:field="searchField" :fields="fields" />
      </div>
      <div class="ctable">
        <ul>
          <li class="head">
            <ul>
              <li class="check">
                <label>
                  <input type="checkbox" v-model="allChecked" />
                  <span><i class="fa-solid fa-check"></i></span>
                </label>
              </li>
              <template v-for="field in fields">
              <li v-if="field.visible">
                <div>
                  <span>{{ field.title }}</span>
                  <div class="sort" :class="{active: sort==field.name || sort=='-'+field.name}">
                    <a href="" class="asc" :class="{active: sort==field.name}" @click.prevent="sort=field.name">
                      <i class="fa-solid fa-arrow-down"></i>
                    </a>
                    <a href="" class="des" :class="{active: sort=='-'+field.name}" @click.prevent="sort='-'+field.name">
                      <i class="fa-solid fa-arrow-up"></i>
                    </a>
                  </div>
                </div>
              </li>
              </template>
              <li class="actions"><a href="" class="btn btn-success">Add new</a></li>
            </ul>
          </li>
          <li v-for="row in visibleRows" :class="{selected: checked.indexOf(row.id)!=-1}">
            <ul>
              <li class="check">
                <label>
                  <input type="checkbox" v-model="checked" :value="row.id" />
                  <span><i class="fa-solid fa-check"></i></span>
                </label>
              </li>
              <template v-for="field in fields">
              <li v-if="field.visible">
                {{ row[field.name] }}
              </li>
              </template>
              <li class="actions">
                <a href="" class="btn btn-primary">Edit</a>
                <a href="" class="btn btn-danger">Remove</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <DataPager :pages="115" v-model="currentPage" />
    </section>
</template>
<script>
export default {
  data: ()=>({
    currentPage: 0,
    searchField: null,
    sort: null,
    searchText: "",
    checked: [],
    filters: [
//       {title: "Apacer"},
//       {title: "SSD"},
    ],
    fields: [
    ],
    rows: [
    ],
  }),
  computed: {
    allChecked: {
      get() {
        for(var row of this.visibleRows) {
          if (this.checked.indexOf(row.id)==-1)
            return false;
        }
        return true;
      },
      set(value) {
        if (value)
          this.checked=this.visibleRows.map(row=>row.id);
        else
          this.checked=[];
      },
    },
    visibleRows() {
      return this.rows.filter(item=>{
        // TODO use server side data...
        var searchStr=this.searchText?(this.searchText+"").toLowerCase():"";
        if (this.searchField && searchStr)
          return (row[this.searchField]+"").toLowerCase().indexOf(searchStr)!=-1;
        else if (searchStr) {
          var found=false;
          for(var field in item)
            if ((item[field]+"").toLowerCase().indexOf(searchStr)!=-1)
              found=true;
          return found;
        }
        return true;
      });
    },
  },
}
</script>
